var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m43.03 1.23.4 8.08A24.2 24.2 0 0 0 1.2 20.5a1.17 1.17 0 0 0 1.15 1.39h4.8a1.17 1.17 0 0 0 1.13-.9 17.18 17.18 0 0 1 30.96-5.57l-9.9-.47a1.17 1.17 0 0 0-1.24 1.17v4.63a1.17 1.17 0 0 0 1.17 1.17h19.56A1.17 1.17 0 0 0 50 20.74V1.17A1.17 1.17 0 0 0 48.83 0H44.2a1.17 1.17 0 0 0-1.17 1.23ZM24.98 42.19a17.15 17.15 0 0 1-14.25-7.6l9.94.47a1.17 1.17 0 0 0 1.22-1.17v-4.63a1.17 1.17 0 0 0-1.17-1.17H1.17A1.17 1.17 0 0 0 0 29.27v19.56A1.17 1.17 0 0 0 1.17 50H5.8a1.17 1.17 0 0 0 1.17-1.23l-.4-8.06a24.2 24.2 0 0 0 42.2-11.2 1.17 1.17 0 0 0-1.15-1.39h-4.79a1.17 1.17 0 0 0-1.14.9 17.17 17.17 0 0 1-16.7 13.16Z",
    "data-name": "Icon awesome-sync"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncing);
export default __webpack_public_path__ + "static/media/syncing.66205f89d27d1ba915aab59e8b84e520.svg";
export { ForwardRef as ReactComponent };